import {Stack} from '@mantine/core';
import {ApplicationScreenshot,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";


export const Profile = ({record}: { record: ApplicationScreenshot }) => {

    const properties = [
        {
            label: 'URL',
            value: record.url as string,
            span: 12,
        }, {
            label: 'Path',
            value: record.path as string,
            span: 12,
        }, {
            label: 'CSS Selector',
            value: record.selector as string,
            span: 12,
        }, {
            label: 'Viewport',
            value: `${record.viewportWidth || 1920}x${record.viewportHeight || 1080}`,
            span: 12,
        }, {
            label: 'Full Page',
            value: record.fullPage ? 'Yes' : 'No',
            span: 12,
        }, {
            label: 'Device Scale Factor',
            value: String(record.deviceScaleFactor || 1),
            span: 12,
        }, {
            label: 'Status',
            value: record.status as string,
            span: 12,
        }];

    const properties2 = [
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }];


    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
            {record.status === 'FAILED' && record.errorMessage && (
                <PlatformPropertyCard properties={[{
                    label: 'Error',
                    value: record.errorMessage,
                    span: 12,
                }]}/>
            )}
        </Stack>
    );


};
